export default __webpack_public_path__ + "static/media/BottomStars.bee40125.svg";